import { cn } from "@/lib/utils";

export type ClientStatusVariant = "success" | "error" | "info";

export function ClientStatusMessage(props: {
  variant: ClientStatusVariant;
  title?: string;
  message: string;
  className?: string;
}) {
  const { variant, title, message, className } = props;

  const styles =
    variant === "error"
      ? "border-destructive/40 bg-destructive/10 text-destructive"
      : variant === "success"
        ? "border-emerald-500/25 bg-emerald-500/10 text-emerald-700"
        : "border-sky-500/25 bg-sky-500/10 text-foreground";

  return (
    <div className={cn("rounded-xl border p-3 text-sm", styles, className)}>
      {title ? <p className="mb-1 text-xs font-semibold uppercase tracking-wide">{title}</p> : null}
      <p className={variant === "info" ? "text-foreground/90" : undefined}>{message}</p>
    </div>
  );
}

